import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { usdtContract } from "../../utils/contractHelpers";
import { useWeb3React } from "../useWagmiCompat";
import Environment from "../../utils/Environment";

const useApproveNft = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.busd;
  const nftContractAddress = Environment.nftPurchase;
  const contract = usdtContract(tokenAddress, web3);

  const approveNft = useCallback(
    async (amount) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      const nd = web3.utils.toWei(amount.toString(), "ether");

      try {
        return new Promise(async (resolve, reject) => {
          let gas;
          try {
            gas = await contract.methods.approve(nftContractAddress, nd).estimateGas({
              from: account,
            });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .approve(nftContractAddress, nd)
            .send({ from: account, gas })
            .on("transactionHash", (hash) => {
              console.log("Approval tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("Approval confirmed:", receipt);
              resolve({ transactionHash: receipt.transactionHash, receipt });
            })
            .on("error", (error) => {
              console.error("Approval failed:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3, nftContractAddress]
  );

  return { approveNft };
};

export default useApproveNft;

// import { useCallback, useState } from "react";
// import useWeb3 from "../useWeb3";
// import { usdtContract } from "../../utils/contractHelpers";
// import { useWeb3React } from "../useWagmiCompat";
// import Environment from "../../utils/Environment";

// const ApproveNft = () => {

//   const [balance, setBalance] = useState(null)
//   const { account } = useWeb3React();
//   const web3 = useWeb3();
//   const tokenAddress = Environment.busd;
//   const tokenAddress1 = Environment.nftPurchase;
//   const contract = usdtContract(tokenAddress, web3);


//   const approveNft = useCallback(
//     async (amount) => {
//       try {
//         let nd = web3.utils.toWei(amount.toString(), "ether");
//         // let gasPrice = await web3.eth.getGasPrice();
//         // gasPrice = parseInt(gasPrice) + 5000000000;
//         const gas = await contract.methods
//           .approve(tokenAddress1, nd)
//           .estimateGas({ from: account });
//         // let gasPrice = await web3.eth.getGasPrice();
//         const details = await contract.methods
//           .approve(tokenAddress1, nd)
//           .send({
//             from: account,
//             gas: gas,
//             // gasPrice,
//           });
//         return details;
//         // console.log('sdsdss' ,  buy)
//         // return details;
//       } catch (error) {
//         throw error;
//       }
//     },
//     [contract, account,web3]
//   );
//   return {approveNft: approveNft};
// };
// export default ApproveNft;